import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ClientManagement, CLIENT_SCOPES } from "../../modules/client-management";
import TenantContextBanner from "../../components/common/TenantContextBanner";
import useAuth from "../../hooks/useAuth";

const ClientsPage = () => {
  const { isTenantUser, isSystemUser, activeTenantId } = useAuth();
  const location = useLocation();
  const isTenantScope =
    isTenantUser || location.pathname.startsWith("/tenant-");

  if (isSystemUser && isTenantScope && !activeTenantId) {
    return <Navigate to="/tenantmgmt" replace />;
  }

  return (
    <>
      {isTenantScope && !isTenantUser ? <TenantContextBanner /> : null}
      <ClientManagement
        scope={isTenantScope ? CLIENT_SCOPES.TENANT : CLIENT_SCOPES.SYSTEM}
      />
    </>
  );
};

export default ClientsPage;
